export default __webpack_public_path__ + "static/media/Movo-Partnership-1.eb599d65.png";